import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

const stepIcons = [
  // Step 1 — Search/find (lime)
  <svg key={0} className="step__ico" viewBox="0 0 30 30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="13" cy="13" r="7" />
    <path d="m22 22-3.5-3.5" />
  </svg>,
  // Step 2 — Join/link (mint)
  <svg key={1} className="step__ico" viewBox="0 0 30 30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>,
  // Step 3 — Reward/gift (yellow)
  <svg key={2} className="step__ico" viewBox="0 0 30 30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 12 20 22 10 22 10 12" />
    <rect x="6" y="7" width="18" height="5" />
    <line x1="15" y1="22" x2="15" y2="7" />
    <path d="M15 7H9.5a2.5 2.5 0 0 1 0-5c1.5 0 3 1.5 5.5 5z" />
    <path d="M15 7h5.5a2.5 2.5 0 0 0 0-5c-1.5 0-3 1.5-5.5 5z" />
  </svg>,
];

export default function HowItWorksComponent() {
  const headRef = useRevealOnScroll<HTMLDivElement>();
  const step1Ref = useRevealOnScroll<HTMLElement>();
  const step2Ref = useRevealOnScroll<HTMLElement>();
  const step3Ref = useRevealOnScroll<HTMLElement>();

  const steps = [
    { ref: step1Ref, numKey: 'joinPage.v2.howItWorks.step1.number', titleKey: 'joinPage.v2.howItWorks.step1.title', bodyKey: 'joinPage.v2.howItWorks.step1.body' },
    { ref: step2Ref, numKey: 'joinPage.v2.howItWorks.step2.number', titleKey: 'joinPage.v2.howItWorks.step2.title', bodyKey: 'joinPage.v2.howItWorks.step2.body' },
    { ref: step3Ref, numKey: 'joinPage.v2.howItWorks.step3.number', titleKey: 'joinPage.v2.howItWorks.step3.title', bodyKey: 'joinPage.v2.howItWorks.step3.body' },
  ];

  return (
    <section className="section-pad" id="how" aria-labelledby="jp-hiw-title">
      <div className="wrap">
        <div ref={headRef} className="sec-head reveal">
          <span className="eyebrow" style={{ justifyContent: 'center' }}>
            <span className="dot" />{t('joinPage.v2.howItWorks.label')}
          </span>
          <h2 className="display" id="jp-hiw-title">{t('joinPage.v2.howItWorks.title')}</h2>
          <p className="lead">{t('joinPage.v2.howItWorks.subtitle')}</p>
        </div>
        <div className="steps">
          {steps.map((step, i) => (
            <article key={i} ref={step.ref} className="step reveal">
              <div className="step__num">Step {t(step.numKey)}</div>
              {stepIcons[i]}
              <h3>{t(step.titleKey)}</h3>
              <p>{t(step.bodyKey)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
